'use strict';

import Stack from '@mui/material/Stack';
import React, { memo, useCallback } from 'react';

import Dialog from '@mui/material/Dialog';
import Logo from 'js/components/UI-Elements/Logo';

import { DialogContent, DialogTitle } from '@mui/material';
import Typography from '@mui/material/Typography';
import SwipeableViews from 'react-swipeable-views';
import LoginForm from 'js/components/Login/LoginForm';
import RestorePasswordForm from 'js/components/Login/RestorePasswordForm';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import Style from './LoginDialog.module.less';
import LanguageSelectorContainer from '../LanguageSelector/LanguageSelectorContainer';
import useFirebaseAnalytics, { FIREBASE_EVENTS } from '../../hooks/useFirebaseAnalytics';
import Box from '@mui/material/Box';

const LoginDialog = ({ shown, doLogin, loggingIn, doRestorePassword, view, setView }) => {
  const analytics = useFirebaseAnalytics();

  const handleOnSlide = (destination) =>
    useCallback(() => {
      setView(destination);

      if (view === 0) {
        analytics.logEvent(FIREBASE_EVENTS.LOGIN_RESTORE_BACK);
      } else {
        analytics.logEvent(FIREBASE_EVENTS.LOGIN_RESTORE);
      }
    }, []);

  return (
    <Dialog
      data-testid="login-dialog"
      open={shown}
      maxWidth={'xs'}
      fullWidth
      scroll={'body'}
      style={{ opacity: loggingIn ? 0 : 1 }}
      classes={{ paper: Style.dialogPaper }}
    >
      <DialogTitle className={Style.Title} disableTypography>
        <Box
          sx={{
            width: '100%',
            p: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              maxWidth: '50%',
            }}
          >
            <Logo variant={'full'} />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent classes={{ root: Style.Content }}>
        <Stack direction={'column'}>
          <Grid>
            <Box className={Style.Language}>
              <LanguageSelectorContainer />
            </Box>

            <SwipeableViews axis={'x'} index={view} slideClassName={Style.Slider}>
              <Typography component="div" className={Style.Slide}>
                <LoginForm shown={view === 0} onSubmit={doLogin} onSlide={handleOnSlide(1)} />
              </Typography>
              <Typography component="div" className={Style.Slide}>
                <RestorePasswordForm
                  shown={view === 1}
                  onSubmit={doRestorePassword}
                  onSlide={handleOnSlide(0)}
                />
              </Typography>
            </SwipeableViews>
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

LoginDialog.propTypes = {
  shown: PropTypes.bool,
  loggingIn: PropTypes.bool,
  view: PropTypes.number,
  setView: PropTypes.func,
  doLogin: PropTypes.func,
  doRestorePassword: PropTypes.func,
};

export default memo(LoginDialog);
